import { PromiseLater } from "@cbar/cbar-utility";
import { sendSuccessMessage } from "../utility/messages.js";
const DEFAULT_TIMEOUT = 20000;
export const startSilentLogin = async (options) => {
    const promise = new PromiseLater();
    registerCallback();
    registerMessageListener(promise);
    createIframe(options);
    registerTimeout(promise, options.timeout || DEFAULT_TIMEOUT);
    return promise;
};
export const silentLoginCallback = () => {
    if (!window.parent?.silentLoginCallback) {
        return;
    }
    window.parent.silentLoginCallback(window.location.href);
};
function createIframe({ authUrl, iframeContainer }) {
    const iframe = document.createElement('iframe');
    iframe.src = authUrl;
    iframe.style.display = 'none';
    const container = iframeContainer || document.body;
    container.appendChild(iframe);
    return iframe;
}
function registerTimeout(promise, timeout) {
    setTimeout(() => {
        unregisterCallback();
        promise.reject('Timed out waiting for response from cbar-login iframe');
    }, timeout);
}
function registerCallback() {
    window.silentLoginCallback = sendSuccessMessage;
}
function unregisterCallback() {
    window.silentLoginCallback = undefined;
}
function registerMessageListener(promise) {
    window.addEventListener('message', (event) => {
        if (!isCbarLoginEvent(event)) {
            return;
        }
        unregisterCallback();
        if (event.data.message === 'error') {
            promise.reject(`cbar-login failed with error: ${event.data.error}`);
            return;
        }
        promise.resolve(event.data.redirectUrl);
    });
}
function isCbarLoginEvent(event) {
    return event.data?.source === 'cbar-login';
}
